// The camera page's "Save videos of my exercises" choice, per session and on by default. Sent with the
// pose room request; Django records only while its flag is on.
const key = sessionId => `recordExerciseVideo:${sessionId}`;

export function recordExerciseVideo(sessionId) {
  try {
    return localStorage.getItem(key(sessionId)) !== 'false';
  } catch (error) {
    return true;
  }
}

export function setRecordExerciseVideo(sessionId, on) {
  try {
    localStorage.setItem(key(sessionId), on ? 'true' : 'false');
  } catch (error) {
    // a private window: the choice lasts this page only
  }
}
